import { Button, Card, Col, Row, message, Spin, Modal } from 'antd'; // 🧠 import Modal
import axios from 'axios';
import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../utils/BaseUrl';

const PendingGymsPage = () => {
  const [gyms, setGyms] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchGyms = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/Gym/gyms`, {
        params: { isActive: false },
      });
      setGyms(response.data);
    } catch (err) {
      message.error('Không thể tải danh sách gym chưa duyệt.');
    } finally {
      setLoading(false);
    }
  };

  const confirmApprove = (gymId, gymName) => {
    Modal.confirm({
      title: `Bạn có chắc chắn muốn duyệt phòng gym "${gymName}"?`,
      okText: 'Duyệt',
      cancelText: 'Hủy',
      okType: 'primary',
      onOk: () => handleApprove(gymId),
    });
  };

  const handleApprove = async (gymId) => {
    try {
      await axios.put(`${API_BASE_URL}/api/Gym/update-status/${gymId}`);
      message.success('Đã duyệt phòng gym.');
      fetchGyms();
    } catch (err) {
      message.error('Duyệt thất bại.');
    }
  };

  useEffect(() => {
    fetchGyms();
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 24 }}>Danh sách phòng gym chờ duyệt</h2>

      {loading ? (
        <Spin size="large" />
      ) : gyms.length === 0 ? (
        <p>Không có phòng gym nào đang chờ duyệt.</p>
      ) : (
        <Row gutter={[24, 24]}>
          {gyms.map((gym) => (
            <Col xs={24} sm={12} md={8} lg={6} key={gym.gymId}>
              <Card
                hoverable
                cover={
                  <img
                    alt={gym.name}
                    src={gym.mainImage || 'https://beast.com.vn/wp-content/uploads/2024/07/thiet-ke-phong-gym-10.webp'}
                    style={{ height: 180, objectFit: 'cover' }}
                  />
                }
              >
                <h3>{gym.name}</h3>
                <p><strong>Địa chỉ:</strong> {gym.address}</p>
                <p><strong>Giờ mở cửa:</strong> {gym.openingHours}</p>
                <p><strong>Trạng thái:</strong> {gym.status}</p>
                <Button
                  type="primary"
                  onClick={() => confirmApprove(gym.gymId, gym.name)}
                  style={{ marginTop: 8 }}
                >
                  Duyệt phòng gym
                </Button>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default PendingGymsPage;
